import {LitElement, html, property, CSSResultArray, TemplateResult} from 'lit-element';
import { customElement } from 'lit/decorators.js';
import {styles} from './nile-tag.css';

/**
 * Nile icon component.
 *
 * @tag nile-tag
 *
 */
@customElement('nile-tag')
export class NileTag extends LitElement {
  /** The tag's theme variant. */
  @property({ reflect: true }) variant: 'primary' | 'success'  = 'primary';

  /** The tag's size. */
  @property({ reflect: true }) size: 'small' | 'medium' | 'large' = 'medium';

  /** Makes the tag removable and shows a remove button. */
  @property({ type: Boolean }) removable = false;


  static styles = styles;




  /* #endregion */

  handleRemoveClick(event: Event){
    event.stopPropagation();
    this.dispatchEvent(
      new CustomEvent('nile-remove', {
        bubbles: true,
        composed: true
      })
    );
  }

  /* #region Methods */

  /**
   * Render method
   * @slot This is a slot test
   */
  public render(): TemplateResult {
    console.log(this.removable);
    return html`
      <span class="tag tag--${this.size} ${!this.removable ? 'tag--without-remove' : ''} ">
        <slot part="content" class="tag__content"></slot>

        ${this.removable
          ? html`
              <span class="tag__remove ">
                <nile-icon
                  name="error"
                  @click=${this.handleRemoveClick}
                ></nile-icon>
              </span>
            `
          : ''}
      </span>
    `;
  }

  /* #endregion */
}

export default NileTag;

declare global {
  interface HTMLElementTagNameMap {
    'nile-tag': NileTag;
  }
}
